module.exports = __webpack_public_path__ + "static/media/news.eaaf0549.svg";